import { getFetchRequest } from '../../network-adapter/fetch-request'
import { UserBasicApiResponseType } from '../../../components/Common/user-provider/types/user-basic'
import { GATEWAY_HOST } from '../../../api/apiConstants'

const getFullHeaders = headers => {
  return {
    'Content-Type': 'application/json',
    platform: 'web',
    ...headers,
  }
}

export const getUserBasicData = async ({
  headers,
  queryParams = {},
  fromMixpanel = false,
}): Promise<UserBasicApiResponseType> => {
  const parsedUrl = new URL(`${GATEWAY_HOST}/ind-investment/api/v4/user/basic/`)
  Object.keys(queryParams).forEach(key => {
    parsedUrl.searchParams.set(key, queryParams[key])
  })
  const resp = await getFetchRequest({
    url: parsedUrl.toString(),
    config: {
      headers: getFullHeaders(headers),
    },
    notHandleError: fromMixpanel,
  })
  return resp
}
